var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"QS420_mobile_video_witness"},[_c('mobileVideoWitness',{ref:"M0002WitnessInPersonRef",attrs:{"bizData":_vm.bizData,"historyData":_vm.historyData,"oppBusiData":_vm.oppBusiData,"isDisabled":_vm.isDisablePage},on:{"on-next-click":_vm.nextStep}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0682c380","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/style-rem-loader??ref--1!./src/business/businessFile/QS420/QS420_mobile_video_witness.vue
// module id = 1240
// module chunks = 2